// extracted by mini-css-extract-plugin
export default {"importhistory":"ImportHistory_importhistory__6wEPO","importertype":"ImportHistory_importertype__96X7J","right":"ImportHistory_right__btEwE"};